import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {
    TEXT_INPUT_LABEL_MAX,
    TEXT_INPUT_LABEL_MIN,
    TEXT_INPUT_PLACEHOLDER_MAX,
    TEXT_INPUT_PLACEHOLDER_MIN,
    TEXT_INPUT_REGEX_MAX,
    TEXT_INPUT_REGEX_MESSAGE_MAX,
} from './constant';

export const inputElementValidator = z.object({
    type: z.literal(ELEMENT.TEXT_INPUT),
    label: z
        .string()
        .min(TEXT_INPUT_LABEL_MIN, `label;min;${TEXT_INPUT_LABEL_MIN}`)
        .max(TEXT_INPUT_LABEL_MAX, `label;max;${TEXT_INPUT_LABEL_MAX}`),
    placeholder: z
        .string()
        .min(TEXT_INPUT_PLACEHOLDER_MIN, `placeholder;min;${TEXT_INPUT_PLACEHOLDER_MIN}`)
        .max(TEXT_INPUT_PLACEHOLDER_MAX, `placeholder;max;${TEXT_INPUT_PLACEHOLDER_MAX}`),
    validationType: z.string().optional(),
    regex: z.string().optional(),
    regexErrorMessage: z.string().optional(),
});

export const regexFieldValidator = z.string().min(1, 'regex;min;1').max(TEXT_INPUT_REGEX_MAX, `regex;max;${TEXT_INPUT_REGEX_MAX}`);

export const regexErrorMessageFieldValidator = z
    .string()
    .min(2, 'regexErrorMessage;min;1')
    .max(TEXT_INPUT_REGEX_MESSAGE_MAX, `regexErrorMessage;max;${TEXT_INPUT_REGEX_MESSAGE_MAX}`);

export const inputElementValidatorExtended = inputElementValidator.superRefine((data, ctx) => {
    if (data.validationType === 'regex') {
        try {
            regexFieldValidator.parse(data.regex);
        } catch (err) {
            if (err instanceof z.ZodError) {
                err.errors.forEach((e) => ctx.addIssue({path: ['regex'], code: z.ZodIssueCode.custom, message: e.message}));
            }
        }

        try {
            regexErrorMessageFieldValidator.parse(data.regexErrorMessage);
        } catch (err) {
            if (err instanceof z.ZodError) {
                err.errors.forEach((e) => ctx.addIssue({path: ['regexErrorMessage'], code: z.ZodIssueCode.custom, message: e.message}));
            }
        }
    }
});
